import React from "react";
import {  Box,  Typography,  Radio,  RadioGroup,  FormControlLabel,  FormControl } from "@mui/material";
import { typo } from "../../../../assets/fonts/font";
import colorConfigs from "../../../../configs/colorConfigs";
import assets from "../../../../assets";

interface PaymentMethodSectionProps {
  paymentMethod: string;
  onPaymentMethodChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PaymentMethodSection = ({
  paymentMethod,
  onPaymentMethodChange,
}: PaymentMethodSectionProps) => {
  return (
    <Box
      sx={{
        padding: "1.5rem",
        border: "1px solid var(--color-black)",
        borderRadius: "1rem",
        backgroundColor: "var(--color-white)",
        mr: { md:2, xs: 0 },
        mt: { md:2, xs: 2 },
        mb: { md:2, xs: 2 },
      }}
    >
      <Typography sx={{ ...typo.title, mb: 2 }}>Payment Method</Typography>

      <FormControl component="fieldset" fullWidth>
        <RadioGroup
          aria-label="payment method"
          name="payment-method"
          value={paymentMethod}
          onChange={onPaymentMethodChange}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <FormControlLabel
              value="stripe"
              control={
                <Radio
                  sx={{
                    color: colorConfigs.primary,
                    "&.Mui-checked": {
                      color: colorConfigs.primary,
                    },
                  }}
                />
              }
              label={
                <Typography sx={{ ...typo.bodyContent }}>
                  Pay with Stripe
                </Typography>
              }
            />

            <Box
              component="img"
              src={assets.images.paymentButton}
              alt="wallet"
              sx={{ width: "30%" }}
            />
          </Box>

          {paymentMethod === "stripe" && (
            <Box sx={{ pl: 4, mb: 2 }}>
              <Typography sx={{ ...typo.bodyContent, mb: 2 }}>
                You will be redirected to Stripe to complete your payment.
              </Typography>
            </Box>
          )}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};
